// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3Y6Jo","innerContainer":"innerContainer__u3ufq","title":"title__fGF-i","description":"description__3pKWr","linksContainer":"linksContainer__1m_bA"};